import type {
  NotificationCategory,
  renderNotification,
  StorefrontTheme,
} from "@loot-os/api-contract";
import { NotificationItem } from "@loot-os/ui/components/notification-item";

import { StorefrontThemeScope } from "./StorefrontThemeScope";

/** A rendered notification as the storefront's bell lists it, in the store's own palette. */
export function NotificationPreview({
  category,
  rendered,
  theme,
  now,
}: {
  category: NotificationCategory;
  rendered: ReturnType<typeof renderNotification>;
  theme?: StorefrontTheme;
  now: Date;
}) {
  return (
    <StorefrontThemeScope theme={theme} className="rounded-xl p-3 ring-1 ring-border">
      <div className="overflow-hidden rounded-lg border bg-popover text-popover-foreground shadow-sm">
        <div className="border-b px-3 py-2 text-sm font-medium">Notifications</div>
        <div className="p-1">
          <NotificationItem
            notification={{
              category,
              icon: rendered.icon,
              title: rendered.title || "Untitled",
              body: rendered.body,
              imageUrl: rendered.imageUrl,
              action: rendered.action,
              createdAt: now.toISOString(),
              readAt: null,
            }}
            now={now}
          />
        </div>
      </div>
    </StorefrontThemeScope>
  );
}
